import { Component, OnDestroy, OnInit,ViewChild,ChangeDetectorRef ,AfterViewInit,ElementRef } from '@angular/core';

import { Location } from '@angular/common'

import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { GeneralLedgerService } from '../../services/general-ledger.service';
import { POSTED_FILTER_OPTIONS } from '../../constants/posted-filter-options';


@Component({
	selector: 'app-trial-balance',
	templateUrl: './trial-balance.component.html',
	styleUrls: ['./trial-balance.component.scss']
})
export class TrialBalanceComponent implements OnInit {
	periods: any = [];
	default_period: any = [];
	default_toperiod: any = '';
	default_fromperiod: any = '';
	formGroup: UntypedFormGroup;
	loading = false;
	trial_balance: any = [];
	title = '';
	from_period_options: any = [];
	to_period_options: any = [];
	trial_balance_totals: any = [];
	pdflink: any = '';
	excellink: any = '';
	color: any ='';
	hasRun = false;
	postedOptions = POSTED_FILTER_OPTIONS;
	constructor(private location: Location, private generalLedgerService: GeneralLedgerService, private globalSearchService: GlobalSearchService, private fb: UntypedFormBuilder) { }

	ngOnInit(): void {


		this.color = this.globalSearchService.getColor();

		this.generalLedgerService.getPeriods().subscribe( (results: any) => {
			this.periods = results.periods
			this.from_period_options = results.periods
			this.to_period_options = results.periods

			this.formGroup = this.fb.group({
				from_period: [results.default_fromperiod, [Validators.required]],
				to_period: [results.default_toperiod, [Validators.required]],
				posted: ['all', [Validators.required]],
			});
		});

	}

	updateToOptions(value: any) {
		this.to_period_options = this.periods.filter((period) => {
			return parseInt(period.periodno) >= parseInt(value)
		});
	}

	updateFromOptions(value: any) {
		this.from_period_options = this.periods.filter((period) => {
			return parseInt(period.periodno) <= parseInt(value)
		});
	}

	back() {
		this.location.back();
	}

	getTrialBalance() {

		if(this.formGroup.valid) {
			this.loading = true;
			this.generalLedgerService.getTrialBalance(this.formGroup.value).subscribe( (results: any) => {
				this.loading= false;
				this.title = results.title
				this.trial_balance = Array.isArray(results.data) ? results.data : [];
				this.trial_balance_totals = results.total;
				this.excellink = results.excellink;
				this.pdflink = results.pdflink;
				this.hasRun = true;

			});
		}

	}

}
